<template>
  <div id="gfVisualFrame">
    <div id="visualContent"></div>
    <div class="gf_content-layouts"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'VisualFrame',
  data: () => ({}),
  created() {
    this.$center.visualFrame = this;
  },
  methods: {},
});
</script>

<style lang="scss"></style>
